export default {"src":"/_next/static/media/warning.9b70b174.svg","height":19,"width":21,"blurWidth":0,"blurHeight":0};